import { Tag } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Domain, EntityType } from '../../../types.generated';
import { HoverEntityTooltip } from '../../recommendations/renderer/component/HoverEntityTooltip';
import { useEntityRegistry } from '../../useEntityRegistry';
import DomainIcon from '../../domain/DomainIcon';

const DomainLinkContainer = styled(Link)`
    max-width: 100%;
    display: inline-block;
`;

const StyledTag = styled(Tag)<{ fontSize?: number }>`
    ${(props) => props.fontSize && `font-size: ${props.fontSize}px;`}
`;

interface DomainContentProps {
    domain: Domain;
    name?: string;
    closable?: boolean;
    onClose?: (e: any) => void;
    tagStyle?: any | undefined;
    fontSize?: number;
}

function DomainContent({ domain, name, closable, onClose, tagStyle, fontSize }: DomainContentProps) {
    const entityRegistry = useEntityRegistry();

    const displayName = name || entityRegistry.getDisplayName(EntityType.Domain, domain);

    return (
        <StyledTag
            style={tagStyle}
            closable={closable}
            onClose={onClose}
            fontSize={fontSize}
            className="grey-tag-light"
        >
            <DomainIcon ariaLabel={displayName} />
            <span>{displayName}</span>
        </StyledTag>
    );
}

export type Props = {
    domain: Domain;
    name?: string;
    closable?: boolean;
    onClose?: (e: any) => void;
    tagStyle?: any | undefined;
    readOnly?: boolean;
    fontSize?: number;
};

export const DomainLink = ({ domain, name, closable, onClose, tagStyle, fontSize }: Props): JSX.Element => {
    const entityRegistry = useEntityRegistry();
    const urn = domain?.urn;

    return (
        <HoverEntityTooltip entity={domain}>
            <DomainLinkContainer to={entityRegistry.getEntityUrl(EntityType.Domain, urn)}>
                <DomainContent
                    domain={domain}
                    name={name}
                    closable={closable}
                    onClose={onClose}
                    tagStyle={tagStyle}
                    fontSize={fontSize}
                />
            </DomainLinkContainer>
        </HoverEntityTooltip>
    );
};
